import React from 'react'
import FieldColumn from '../field-column'
import { Field } from 'formik'
import MultiSelectField from '../../form/fields/multi-select'
import { buildListAsInputOptions } from '../../../utils/forms'
import { useWorkPeriodEventsQuery } from '../../../queries/work-period-events'

/**
 * Sentinel values for synthetic filter options
 */
const ALL_ABSENCES_SENTINEL = '__all_absences__'
const ALL_PRESENCES_SENTINEL = '__all_presences__'

interface EventsFilterFieldProps {
  disabledQueries?: boolean
  queriesStaleTime?: number
  labels?: {
    allAbsences?: string
    allPresences?: string
  }
}

/**
 * Component for filtering events in a multi-select field
 * Uses work period events data from the API
 * Includes synthetic options for filtering by absence/presence patterns
 */
const EventsFilterField: React.FC<EventsFilterFieldProps> = ({
  disabledQueries,
  queriesStaleTime,
  labels,
}) => {
  const eventsQuery = useWorkPeriodEventsQuery(
    {},
    {
      enabled: !disabledQueries,
      staleTime: queriesStaleTime,
    },
  )

  // Build synthetic options for absence/presence filtering
  const syntheticOptions = [
    { value: ALL_ABSENCES_SENTINEL, label: labels?.allAbsences || 'Toutes les absences' },
    { value: ALL_PRESENCES_SENTINEL, label: labels?.allPresences || 'Toutes les présences' },
  ]

  // Build real event options
  const realEventOptions = buildListAsInputOptions(eventsQuery.data || [], {
    labelKeyPath: 'title',
  })

  // Combine synthetic options with real events (synthetic options appear first)
  const allOptions = [...syntheticOptions, ...realEventOptions]

  return (
    <FieldColumn>
      <Field label="Événements" name="events" component={MultiSelectField} options={allOptions} />
    </FieldColumn>
  )
}

export default EventsFilterField

// Export sentinel values for use in query normalization
export { ALL_ABSENCES_SENTINEL, ALL_PRESENCES_SENTINEL }
